import { intlShape, injectIntl } from 'react-intl';
import { VODCSSModules } from 'shared/utils/wix-connect';

import Icon from 'shared/components/icon/icon';
import WithTooltip from '../with-tooltip/with-tooltip';
import ChannelInfoButton from 'widget/components/channel-actions/channel-info-button';
import ChannelSubscriptionLabel from 'widget/components/channel-actions/channel-subscription-label';
import AccountButton from 'widget/components/account/account-button/account-button';

import translations from '../../translations';
import styles from './channel-actions.styl';

import { sides } from 'shared/constants/popout';


@injectIntl
@VODCSSModules(styles)
export default class ChannelActions extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    intl: intlShape,

    canShowCloseButton: React.PropTypes.bool,
    canShowChannelShare: React.PropTypes.bool,
    canShowChannelInfo: React.PropTypes.bool,
    canShowSignIn: React.PropTypes.bool,
    canShowSubscriptionButton: React.PropTypes.bool,

    onShareRequest: React.PropTypes.func,
    onInfoRequest: React.PropTypes.func,
    onAccountInfoAtOverlayRequest: React.PropTypes.func,
    onSubscriptionRequest: React.PropTypes.func,
    onLogInRequest: React.PropTypes.func,
    onLogOutRequest: React.PropTypes.func,
    onSubscriptionCancelRequest: React.PropTypes.func,
    onCloseRequest: React.PropTypes.func,
  };

  get formatMessage() {
    return this.props.intl.formatMessage;
  }

  wrapWithTooltip(content, tooltipMessage) {
    return (
      <WithTooltip tooltip={tooltipMessage}
                   className={styles.item}
                   innerClassName={styles['tooltip-inner']}>
        {content}
      </WithTooltip>
    );
  }

  get shareButton() {
    const { canShowChannelShare, onShareRequest } = this.props;

    if (!canShowChannelShare) {
      return null;
    }

    const tooltipMessage = this.formatMessage(translations.shareButtonTooltip);
    const content = (
      <Icon name="share"
            data-hook="shareChannelButton"
            className={styles.icon}
            onClick={onShareRequest} />
    );

    return this.wrapWithTooltip(content, tooltipMessage);
  }

  get channelInfoButton() {
    const { channelData, onInfoRequest, canShowChannelInfo } = this.props;

    if (!canShowChannelInfo) {
      return null;
    }

    const tooltipMessage = this.formatMessage(translations.channelInfoTooltip);
    const content = (
      <ChannelInfoButton dataHook="channelInfoButton"
                         className={`${styles.icon} ${styles['icon-channel-info']}`}
                         channelData={channelData}
                         onClick={onInfoRequest} />
    );

    return this.wrapWithTooltip(content, tooltipMessage);
  }

  get channelSubscriptionButton() {
    const { channelData, onSubscriptionRequest, canShowSubscriptionButton } = this.props;

    if (!canShowSubscriptionButton) {
      return null;
    }

    const tooltipMessage = (
      <ChannelSubscriptionLabel dealInfo={channelData.dealInfo}
                                styleName="channel-subscription-tooltip-content" />
    );
    const content = (
      <Icon name="paid"
            data-hook="subscriptionButton"
            className={`${styles.icon} ${styles['icon-paid']}`}
            onClick={onSubscriptionRequest} />
    );

    return this.wrapWithTooltip(content, tooltipMessage);
  }

  get membershipActions() {
    const {
      channelData,
      onSubscriptionRequest,
      onSubscriptionCancelRequest,
      onAccountInfoAtOverlayRequest,
      canShowSignIn,
      onLogInRequest,
      onLogOutRequest,
    } = this.props;

    if (!canShowSignIn) {
      return null;
    }

    return (
      <AccountButton styleName="item icon"
                     channelData={channelData}
                     popoutSide={sides.TOP}
                     onClick={onAccountInfoAtOverlayRequest}
                     onLoginClick={onLogInRequest}
                     onLogoutClick={onLogOutRequest}
                     onSubscribeClick={onSubscriptionRequest}
                     onSubscriptionCancelClick={onSubscriptionCancelRequest} />
    );
  }

  get closeButtonWithTooltip() {
    const { onCloseRequest } = this.props;

    const tooltipMessage = this.formatMessage(translations.close);
    const content = (
      <Icon name="exit"
            data-hook="closeActionBar"
            styleName="icon icon-close"
            onClick={onCloseRequest} />
    );

    return this.wrapWithTooltip(content, tooltipMessage);
  }

  get closeButtonWithLabel() {
    const { onCloseRequest } = this.props;

    const label = this.formatMessage(translations.close);

    return (
      <div styleName="item"
           onClick={onCloseRequest}
           data-hook="closeActionBar">
        <div className={styles.icon}>
          <Icon name="exit"
                styleName="icon icon-close with-label" />
          <span styleName="label">
            {label}
          </span>
        </div>
      </div>
    );
  }

  get closeButton() {
    const { canShowCloseButton } = this.props;

    if (!canShowCloseButton) {
      return null;
    }

    const {
      shareButton,
      channelInfoButton,
      channelSubscriptionButton,
      membershipActions,
      closeButtonWithTooltip,
      closeButtonWithLabel,
    } = this;

    const buttonsExceptClose = [
      shareButton,
      channelInfoButton,
      channelSubscriptionButton,
      membershipActions,
    ];

    return _.some(buttonsExceptClose) ? closeButtonWithTooltip : closeButtonWithLabel;
  }

  render() {
    return (
      <nav styleName="container">
        {this.shareButton}
        {this.channelInfoButton}
        {this.channelSubscriptionButton}
        {this.membershipActions}
        {this.closeButton}
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/channel-actions/channel-actions.js